import { render, staticRenderFns } from "./AdiPaiCureDomiciliariList.vue?vue&type=template&id=855fe8e0"
import script from "./AdiPaiCureDomiciliariList.vue?vue&type=script&lang=js"
export * from "./AdiPaiCureDomiciliariList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports